import { render, staticRenderFns } from "./adjustPlan.vue?vue&type=template&id=328128b2&scoped=true&"
import script from "./adjustPlan.vue?vue&type=script&lang=js&"
export * from "./adjustPlan.vue?vue&type=script&lang=js&"
import style0 from "./adjustPlan.vue?vue&type=style&index=0&id=328128b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328128b2",
  null
  
)

export default component.exports